import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import userImage from "../../Images/user.png";
import jwtDecode from "jwt-decode";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ResetProfilePassword from "../../components/resetProfilePassword/ResetProfilePassword";
import MuiButton from "../../components/muiButton/MuiButton";
import LoadingIndicator from "../../components/loading-indicator/LoadingIndicator";
import NoDataFound from "../../components/nodatafound/NoDataFound";
import UserAction from "../../stores/user/UserAction";

//map state to props
const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [UserAction.REQUEST_USER]),
  user: state.user.user || [],
});

function MyProfile(props) {
  const theme = useTheme();
  const [openPassword, setOpenPassword] = useState(false);

  function fetch() {
    props.dispatch(UserAction.requestUser());
  }

  const { isRequesting } = props;

  useEffect(() => {
    // const auth = jwtDecode(localStorage.getItem("Auth"));
    fetch();
  }, []);

  let data = props.user?.hits?.hits[0]?._source;

  return (
    <Box>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @keyframes anima {
            0% {
              transform: translateY(-100px);
            }
            100% {
              opacity: 1;
              transform: scale(1);
            }
          }
        @keyframes rollOpen {
          0% {
            transform: translateY(-100px) rotateX(90deg);
            opacity: 0;
          }
          100% {
            opacity: 1;
            transform: scale(1) rotateX(0deg);
          }
        }
      `,
        }}
      />
      <Typography
        variant="h2"
        my={2}
        fontWeight={theme.typography.fontWeightBold}
      >
        My Profile
      </Typography>

      {data ? (
        <LoadingIndicator isActive={isRequesting}>
          {!isRequesting && (
            <>
              <Divider variant="fullWidth" className="divider" />
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                sx={{
                  animation: `rollOpen 0.4s ease-in-out`,
                }}
              >
                <Card
                  sx={{
                    width: "auto",
                    marginTop: "2%",
                    border: "none",
                    borderRadius:
                      theme.palette.buttonComponent.borderRadius.medium,
                    padding: theme.palette.buttonComponent.borderRadius.small,
                    height: "auto",
                    boxShadow: "8px 8px 10px rgba(0,0,0,0.9)",
                  }}
                >
                  <CardContent sx={{ animation: `anima 0.7s ease-in-out` }}>
                    <Avatar
                      alt="profile photo"
                      src={userImage}
                      sx={{
                        width: "15%",
                        height: "15%",
                        position: "left",
                        left: "42%",
                      }}
                    />
                    <Box p={2}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        container
                        spacing={2}
                        justifyContent={"center"}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          justifyContent={"center"}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            container
                            spacing={2}
                            p={1}
                            justifyContent={"center"}
                          >
                            <Grid
                              item
                              lg={6}
                              md={6}
                              sm={6}
                              textAlign="center"
                              ml={10}
                            >
                              {/* <label
                        style={{
                          fontWeight: theme.typography.fontWeightBold,
                          fontSize: "18px",
                        }}
                      >
                        First Name
                      </label>
                      <label
                        style={{
                          fontWeight: theme.typography.fontWeightBold,
                          fontSize: "18px",
                        }}
                      >
                        :
                      </label>
                      <label
                        style={{
                          fontWeight: theme.typography.fontWeightBold,
                          fontSize: "18px",
                        }}
                      >
                        {props.userById.data && props.userById.data.firstName}
                      </label> */}
                              <Grid display={"flex"}>
                                <Grid
                                  item
                                  lg={5}
                                  md={4.5}
                                  sm={6}
                                  textAlign="left"
                                  p={1}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    First Name
                                  </Typography>
                                </Grid>
                                <Grid p={1}>
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    :
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  lg={8}
                                  md={6}
                                  sm={6}
                                  textAlign="left"
                                  p={1}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    {data && data.firstName}
                                  </Typography>
                                </Grid>
                              </Grid>

                              <Grid display={"flex"}>
                                <Grid
                                  item
                                  lg={5}
                                  md={4.5}
                                  sm={6}
                                  textAlign="left"
                                  p={1}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    Last Name
                                  </Typography>
                                </Grid>
                                <Grid p={1}>
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    :
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  lg={8}
                                  md={6}
                                  sm={6}
                                  textAlign="left"
                                  p={1}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    {data && data.lastName}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid display={"flex"}>
                                <Grid
                                  item
                                  lg={5}
                                  md={4.5}
                                  sm={6}
                                  textAlign="left"
                                  p={1}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    User Name
                                  </Typography>
                                </Grid>
                                <Grid p={1}>
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    :
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  lg={8}
                                  md={6}
                                  sm={6}
                                  textAlign="left"
                                  p={1}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    {data && data.influencer_name}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid display={"flex"}>
                                <Grid
                                  item
                                  lg={5}
                                  md={4.5}
                                  sm={6}
                                  textAlign="left"
                                  p={1}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    Email ID
                                  </Typography>
                                </Grid>
                                <Grid p={1}>
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    :
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  lg={8}
                                  md={6}
                                  sm={6}
                                  textAlign="left"
                                  p={1}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight:
                                        theme.typography.fontWeightBold,
                                      fontSize: "18px",
                                    }}
                                  >
                                    {data && data.email_address}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid display={"flex"}>
                                <Grid
                                  lg={12}
                                  xl={12}
                                  md={12}
                                  sm={12}
                                  mt={3}
                                  ml={9.5}
                                  textAlign="left"
                                >
                                  <MuiButton
                                    title="Reset Password"
                                    onClick={(event) => {
                                      setOpenPassword(true);
                                    }}
                                    name="Reset Password"
                                    // sx={{}}
                                  ></MuiButton>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </CardContent>
                </Card>

                <ResetProfilePassword
                  open={openPassword}
                  onClose={() => {
                    setOpenPassword(false);
                  }}
                />
              </Grid>
            </>
          )}
        </LoadingIndicator>
      ) : (
        <NoDataFound />
      )}
    </Box>
  );
}

export default connect(mapStateToProps)(MyProfile);
